import React from 'react'
import { OrderDetail } from '../../../../../../modules/API/Orders/models/detailsProductCustomer'
import styled from 'styled-components'
import TitleLayout from '../../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../../kosherTeudot/generic/TitleRowItem'
import EditIcon from '../../../../../../generic/icons/IconLib/PencilIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import { stylePackByID } from '../../../../../../generic/utils/stylePackByPackType'
import StatusCircle from '../../../../../../generic/ui/badge/StatusCircle'

interface Props extends OrderDetail {
  handleNestedProduct: (recID: number) => void
}

const ProductDetailsItem = ({
  Customer_Name, 
  SupplyQty, 
  OrderPacks, 
  Pack_Type, 
  Status, 
  handleNestedProduct,
  RecID
}: Props) => {
  const stylePack = stylePackByID(Pack_Type)
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    handleNestedProduct(RecID)
  }
  return (
    <MainWrapper>
      <TitleLayout
        disableShadow
      >
        <TitleRow>
          <TitleRowItem 
            name={Customer_Name.trim()}
            icon={<UserIcon />}
          />
          <TitleRowItem 
            name={`${OrderPacks}`}
            icon={stylePack.component}
            iconColor={stylePack.color}
          />
          <StatusCircle statusCode={Status} />
        </TitleRow>
        <SideWrapper
          onClick={handleClick}
        >
          <EditIcon />
        </SideWrapper>
      </TitleLayout>
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
  width: 100%;
`
const SideWrapper = styled.div`
  position: absolute;
  left: 0.3em;
  width: 2em;
  height: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #297F76;
  cursor: pointer;

`
export default ProductDetailsItem